<template src="./image.html"></template>

<script>
import axios from 'axios'
  import { store } from '../../../store/store'

  let uploadInstanceSeq = 0

  export default {
    name: 'images',
    props: {
      parent_item: {
        type: Object
      },
      save: {
        type: Function
      },
      resize: {
        type: Boolean,
        default: true
      },
      canUpload: {
        type: Boolean,
        default: true
      },
      showUploadLabel: {
        type: Boolean,
        default: true
      }
    },
    watch: {
      parent_item: function () {
        this.item = this.parent_item
        this.images = Array.isArray(this.item.images) ? this.item.images.slice() : []
      }
    },
    data: function () {
      uploadInstanceSeq += 1
      const uid = 'photo-upload-' + uploadInstanceSeq
      return {
        item: {},
        images: [],
        placeholderSrc: require('../../../assets/img/no-image-available.jpg'),
        dragIndex: null,
        dragOverIndex: null,
        pasteFocused: false,
        uploadInputId: uid,
        uploadLabelId: uid + '-label'
      }
    },
    computed: {
      hasImages: function () {
        return !!(this.item && this.item.images && this.item.images.length)
      }
    },
    methods: {
      imageKey: function (image, index) {
        if (!image) return 'img-' + index
        return (image.filename || image.url || 'img') + '-' + index
      },
      onPasteZoneClick: function (event) {
        if (!this.canUpload) return
        // Don't steal focus from the delete control
        if (event && event.target && event.target.closest && event.target.closest('.image-delete-btn')) return
        const zone = this.$refs.pasteZone
        if (zone && typeof zone.focus === 'function') zone.focus()
      },
      onPaste: function (event) {
        if (!this.canUpload) return
        const files = this.clipboardImageFiles(event)
        if (!files.length) return
        event.preventDefault()
        this.uploadFiles(files)
      },
      clipboardImageFiles: function (event) {
        const out = []
        const clip = event && event.clipboardData
        if (!clip) return out

        const items = clip.items
        if (items && items.length) {
          for (let i = 0; i < items.length; i++) {
            const item = items[i]
            if (!item || item.kind !== 'file') continue
            const type = String(item.type || '')
            if (type.indexOf('image/') !== 0) continue
            const file = item.getAsFile && item.getAsFile()
            if (file) out.push(this.normalizePastedFile(file, i))
          }
        }

        if (!out.length && clip.files && clip.files.length) {
          for (let i = 0; i < clip.files.length; i++) {
            const file = clip.files[i]
            if (!file) continue
            const type = String(file.type || '')
            if (type.indexOf('image/') !== 0) continue
            out.push(this.normalizePastedFile(file, i))
          }
        }
        return out
      },
      normalizePastedFile: function (file, index) {
        if (file && file.name) return file
        const type = (file && file.type) || 'image/png'
        const ext = type.split('/')[1] || 'png'
        return new File([file], 'pasted-image-' + Date.now() + '-' + index + '.' + ext, { type: type })
      },
      changed: function (event) {
        const files = event && event.target && event.target.files
        this.uploadFiles(files)
        if (event && event.target) event.target.value = ''
      },
      uploadFiles: function (files) {
        if (!files || !files.length) return
        const formData = new FormData()
        for (let i = 0; i < files.length; i++) {
          formData.append('images[]', files[i])
        }
        this.upload(formData)
      },
      upload: function (formData) {
        if (formData) {
          axios.post('/storage/images/' + this.resize, formData).then(response => {
            if (this.images != null) {
              for (let i = 0; i < response.data.length; i++) {
                this.images.push(response.data[i])
              }
            } else {
              this.images = response.data
            }
            this.$emit('images', this.images)
          }).catch((error) => {
            console.error('Image upload failed:', error)
            const msg = (error.response && error.response.data && error.response.data.error) || error.message || 'Upload failed'
            alert('Image upload failed: ' + msg)
          })
        }
      },
      remove: function (image) {
        let imgIndex = this.item.images.findIndex(function (sub) {
          return sub.filename === image.filename
        })
        if (imgIndex > -1) {
          this.item.images.splice(imgIndex, 1)
          this.images = Array.isArray(this.item.images) ? this.item.images.slice() : []
          this.$emit('images', this.images)
          if (typeof this.save === 'function') this.save(false)
        }
        if (this.item.id) {
          axios.delete('storage/images/' + image.filename, image.filename)
        }
      },
      onDragStart: function (index, event) {
        if (!this.canUpload) return
        this.dragIndex = index
        this.dragOverIndex = index
        if (event && event.dataTransfer) {
          event.dataTransfer.effectAllowed = 'move'
          event.dataTransfer.setData('text/plain', String(index))
        }
      },
      onDragEnter: function (index) {
        if (!this.canUpload || this.dragIndex == null) return
        this.dragOverIndex = index
      },
      onDragOver: function (event) {
        if (event && event.dataTransfer) event.dataTransfer.dropEffect = 'move'
      },
      onDrop: function (index) {
        if (!this.canUpload || this.dragIndex == null) return
        this.reorderImages(this.dragIndex, index)
        this.dragIndex = null
        this.dragOverIndex = null
      },
      onDragEnd: function () {
        this.dragIndex = null
        this.dragOverIndex = null
      },
      reorderImages: function (fromIndex, toIndex) {
        if (fromIndex === toIndex) return
        const list = Array.isArray(this.item.images) ? this.item.images.slice() : []
        if (fromIndex < 0 || toIndex < 0 || fromIndex >= list.length || toIndex >= list.length) return
        const moved = list.splice(fromIndex, 1)[0]
        list.splice(toIndex, 0, moved)
        this.item.images = list
        this.images = list.slice()
        this.$emit('images', this.images)
        if (typeof this.save === 'function') this.save(false)
      },
      getUrl: function (image) {
        // If image has a full URL (from Spaces CDN), use it directly
        if (image.url && image.url.startsWith('http')) {
          return image.url
        }
        // Fall back to constructing URL from filename (local storage)
        if (image.pending) {
          return store.getters['getImageUrl'] + 'pending/' + image.filename
        } else {
          return store.getters['getImageUrl'] + image.filename
        }
      },
      onImageError: function (e) {
        if (e && e.target) {
          e.target.onerror = null
          e.target.src = 'data:image/svg+xml,' + encodeURIComponent(
            '<svg xmlns="http://www.w3.org/2000/svg" width="120" height="120" viewBox="0 0 120 120"><rect fill="#F9FAFB" width="120" height="120"/><text x="60" y="65" text-anchor="middle" fill="#999" font-size="12" font-family="sans-serif">Image unavailable</text></svg>'
          )
        }
      }
    },
    mounted: function () {
      this.item = this.parent_item
      this.images = Array.isArray(this.item.images) ? this.item.images.slice() : []
    }
  }
</script>

<style scoped>
  input[type="file"] {
    opacity: 0;
    position: absolute;
    z-index: -1;
  }
  .smardie-btn-secondary {
    width: 120px;
    text-align: center;
  }
  .image-upload-title {
    display: block;
  }
  .image-upload-guidance {
    margin: 0.25rem 0 0.75rem;
  }
  .image-uploader--without-title {
    padding-top: 8px;
  }
  .image-uploader--without-title .image-upload-guidance {
    margin-top: 0;
  }
  .image-upload-paste-zone {
    display: block;
    border-radius: 8px;
    outline: 2px solid transparent;
    outline-offset: 4px;
    transition: outline-color 0.15s ease;
  }
  .image-upload-paste-zone.is-paste-focused {
    outline-color: #4DA1FF;
  }
  .image-upload-paste-zone:focus {
    outline-color: #4DA1FF;
  }
  .image-upload-paste-zone:focus:not(:focus-visible) {
    /* keep visible focus for paste affordance even after mouse click */
    outline-color: #4DA1FF;
  }
  img {
    margin-left: 0;
    margin-right: 0;
  }
  /* Fixed square thumb: Semantic UI `.ui.image img` uses max-width:100% + height:auto,
     which in a 4-column grid on mobile shrinks width while a fixed height stretches the img. */
  .ui.image.image-upload-preview {
    position: relative;
    display: block;
    width: 120px;
    max-width: 100%;
    aspect-ratio: 1 / 1;
    height: auto;
    border-radius: 4px;
  }
  .ui.image.image-upload-preview > img {
    width: 100%;
    height: 100%;
    max-width: none;
    aspect-ratio: 1 / 1;
    object-fit: cover;
    border-radius: 4px;
    display: block;
    pointer-events: none;
  }
  .image-upload-column {
    cursor: default;
  }
  .image-upload-column[draggable="true"] {
    cursor: grab;
  }
  .image-upload-column.is-dragging {
    opacity: 0.45;
    cursor: grabbing;
  }
  .image-upload-column.is-drag-over .image-upload-preview {
    outline: 2px solid #4DA1FF;
    outline-offset: 2px;
  }
  .image-delete-btn {
    position: absolute;
    top: -10px;
    right: -10px;
    width: 28px;
    height: 28px;
    padding: 0;
    border: 1.5px solid #FF4C4C;
    border-radius: 50%;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    z-index: 1;
    line-height: 1;
  }
  .image-delete-btn img {
    width: 16px;
    height: 16px;
    margin: 0;
    display: block;
    pointer-events: none;
  }
</style>
